import React from "react";
import Title from "app/components/UI/Title";
import classes from "../CheckoutLayout/CheckoutLayout.module.css";
import renderHTML from "react-render-html";

export const CheckoutProcess = ({ formPayment, isLoading, translate }) => (
  <div className={classes.container_lite} style={{ textAlign: "center" }}>
    <Title component="h2">{translate("Début de la transaction")}</Title>

    {!isLoading && (
      <div  className={classes.checkout_process_form} dangerouslySetInnerHTML={{__html: formPayment}}></div>
    ) || <div style={{textAlign: "center"}}>Veuillez patienter ...</div>}
  </div>
);

export default CheckoutProcess;



// WEBPACK FOOTER //
// ./src/app/components/CheckoutProcess/CheckoutProcess.js